import React, { useEffect, useState } from "react"
import { CardText, Col, Row, Button } from "reactstrap"
import DPTextBox from "../../../framework/components/DPTextBox"
import DPDropDown from "framework/components/DPDropDown"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import ProductExcelUpload from "../../../assets/File/ProductExcel.xlsx";
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPImagePop from 'framework/components/DPImagePop'
import DPImage from "../../../framework/components/DPImage"
import DPTagPop from "../../../framework/components/DPTagPop"
import Tag from "../../../assets/images/support/Tag.png"
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from "react";

import {
  getUnitDetails,
  getLanguageDetails,
  getPurchaseModeDetails,
} from "./ProductController"
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import DPTextBoxTow from "framework/components/DPTextBoxTow"
import { Numeric } from "framework/validators/TextValidation"
const ProductGenContent = ({
  GetSelectRow,
  Gen_Code,
  Gen_Code_OnChange,
  Gen_Code_onKeyPress,
  Gen_Code_onBlur,
  Gen_Code_Enabled,
  Gen_DataSearch,
  Gen_Desc,
  Gen_Desc_OnBlur,
  Gen_Desc_OnChange,
  Gen_Desc_Enabled,
  Gen_POSDesc,
  Gen_POSDesc_OnChange,
  Gen_POSDesc_Enabled,
  Gen_TouchDesc,
  Gen_TouchDesc_OnChange,
  Gen_TouchDesc_Enabled,
  Gen_StockCode,
  Gen_StockCode_OnChange,
  Gen_StockCode_Enabled,
  Gen_VendorPLU,
  Gen_VendorPLU_OnChange,
  Gen_VendorPLU_Enabled,
  Gen_CaseSize,
  Gen_CaseSize_OnChange,
  Gen_CaseSize_onBlur,
  Gen_CaseSize_Enabled,
  Gen_CostPrice,
  Gen_CostPrice_OnChange,
  Gen_CostPrice_onBlur,
  Gen_CostPrice_Enabled,
  Gen_MarkupCost,
  Gen_MarkupCost_OnChange,
  Gen_MarkupCost_onBlur,
  Gen_MarkupCost_Enabled,
  Gen_SellingPrice,
  Gen_SellingPrice_OnChange,
  Gen_SellingPrice_onBlur,
  Gen_SellingPrice_Enabled,
  Gen_PackPrice,
  Gen_PackPrice_OnChange,
  Gen_PackPrice_Enabled,
  Gen_PackPrice_onBlur,
  Gen_AvgCost,
  Gen_AvgCost_OnChange,
  Gen_AvgCost_Enabled,
  Gen_FixedGP,
  Gen_FixedGP_OnChange,
  Gen_FixedGP_onBlur,
  Gen_FixedGP_Enabled,
  Gen_CurrentGP,
  Gen_CurrentGP_OnChange,
  Gen_CurrentGP_Enabled,
  Gen_MaxDis,
  Gen_MaxDis_OnChange,
  Gen_MaxDis_onBlur,
  Gen_MaxDis_Enabled,
  Gen_MaxDisAmt,
  Gen_MaxDisAmt_OnChange,
  Gen_MaxDisAmt_onBlur,
  Gen_MaxDisAmt_Enabled,
  Gen_MaxAllowQty,
  Gen_MaxAllowQty_OnChange,
  Gen_MaxAllowQty_Enabled,
  Gen_MaxAllowQty_onBlur,
  Unit,
  Gen_Unit,
  Gen_Unit_Enabled,
  PurchasingMode,
  Gen_PurchasingMode,
  Gen_PurchasingMode_Enabled,
  Language1,
  Gen_Language1,
  Gen_Language1_Enabled,
  Language2,
  Gen_Language2,
  Gen_Language2_Enabled,
  Hed_CodeSearchTrigger, // Calls when search window is required to be poped up
  Hed_CodeSearchOpen, // Open status of the Search window

  menuCode,
  onButtonClick,
  btnDisable,
  SearchDisable,
  showFileUpload,
  valueUpload,
  setVenderPLU,
  imagesrc,
  proDescEnable,
  proPosDescDisable,
  proTouchDescDisable,
  proStockDisable,
  proVendorDisable,
  ProUnitDisable,
  ProPurModeDisable,
  ProCSDisable,
  ProCostDisable,
  ProMarkupDisable,
  ProSellDisable,
  ProPackDisable,
  ProAVGDisable,
  ProFixGPDisable,
  ProGPDisable,
  ProMaxDiscDisable,
  ProMaxDiscAmtDisable,
  ProMaxAllowQtyDisable,
  ProPictureDisable,
  ProLan1Disable,
  ProLan2Disable,
  ProReturnDisable,
  autoCode,
  AddNew,
  Tab1Modify,
  Tab1Create,
  Return_Code,
  Return_Description,
  Return_DataSearch,
  Return_Code_onKeyPress,
  Return_Code_onBlur,
  Return_Code_OnChange,
  Return_CodeSearchOpen,
  Return_CodeSearchTrigger,
  GetSelectReturnRow,
  hideFields,
  dbMinSell,
  Gen_SetMinSell_OnChange,
  Gen_SetMinSell_onBlur,
  ProMinSellDisable,
  is_IR_user,
  logLocation,
  proFormData,
  setProFormData,
  shortExpieryDisable,
  shortExpieryHide
}) => {

  const {
    txnDecimalAmt
  } = useContext(Context);


  const [HeadColumns, setHeadColumns] = useState([])
  const ApiURL = window.Links.ApiURL

  const [isOpen, SetIsOpen] = useState(false)
  const [isOpenT, SetIsOpenT] = useState(false)

  const showPop = () => {
    SetIsOpen(!isOpen)
  }
  const showPopT = () => {
    SetIsOpenT(!isOpenT)
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const [optionUnit, setoptionGroup] = useState([])
  const [optionPurchasingMode, setoptionPurchase] = useState([])

  React.useEffect(async () => {
    const unitData = await getUnitDetails()
    setoptionGroup(unitData)

    const purchsasemodes = await getPurchaseModeDetails()
    setoptionPurchase(purchsasemodes)

  }, [menuCode])


  const lastThreeDigits = logLocation.slice(-3); // Extracts the last 3 digits
  const filterBy = is_IR_user ? ` AND (PLU_CODE LIKE '000%' OR PLU_CODE LIKE '${lastThreeDigits}%')` : 'a';



  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>

                <Col sm={12} md={6} className="mb-4-sm">
                  <Row>
                    <Col>
                      <DPTextBoxButton
                        rowClass="mb-4-sm"
                        labelText="Code *"
                        textType="text"
                        maxLength="25"
                        value={Gen_Code}
                        onChange={Gen_Code_OnChange}
                        onKeyPress={Gen_Code_onKeyPress}
                        onBlur={Gen_Code_onBlur}
                        disabled={Gen_Code_Enabled ? true : AddNew && Tab1Create ? false : AddNew == false && Tab1Modify ? false : true}
                        onButtonClick={onButtonClick}
                        btnDisable={btnDisable}
                        placeholder={autoCode}

                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        onClick={Gen_DataSearch}
                        color="success"
                        className="btn-sm"
                        // disabled={SearchDisable ? true : AddNew && Tab1Create ? false : AddNew == false && Tab1Modify ? false : true}
                        disabled={SearchDisable}
                        size="sm"
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>
                  {<Row hidden={proDescEnable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Description *"
                        textType="text"
                        maxLength="40"
                        value={Gen_Desc}
                        onBlur={Gen_Desc_OnBlur}
                        onChange={Gen_Desc_OnChange}
                        disabled={Gen_Desc_Enabled ? true : AddNew && Tab1Create ? proDescEnable ? true : false : AddNew == false && Tab1Modify ? proDescEnable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>}
                  <Row hidden={proPosDescDisable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="POS Description"
                        textType="text"
                        maxLength="40"
                        value={Gen_POSDesc}
                        onChange={Gen_POSDesc_OnChange}
                        disabled={Gen_POSDesc_Enabled ? true : AddNew && Tab1Create ? proPosDescDisable ? true : false : AddNew == false && Tab1Modify ? proPosDescDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={proTouchDescDisable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Touch Description"
                        textType="text"
                        maxLength="40"
                        value={Gen_TouchDesc}
                        onChange={Gen_TouchDesc_OnChange}
                        disabled={Gen_TouchDesc_Enabled ? true : AddNew && Tab1Create ? proTouchDescDisable ? true : false : AddNew == false && Tab1Modify ? proTouchDescDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={proStockDisable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Stock Code "
                        textType="text"
                        maxLength="25"
                        value={Gen_StockCode}
                        onChange={Gen_StockCode_OnChange}
                        disabled={Gen_StockCode_Enabled ? true : AddNew && Tab1Create ? proStockDisable ? true : false : AddNew == false && Tab1Modify ? proStockDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={proVendorDisable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Vendor PLU"
                        textType="text"
                        maxLength="25"
                        value={Gen_VendorPLU}
                        onChange={Gen_VendorPLU_OnChange}
                        disabled={Gen_VendorPLU_Enabled ? true : AddNew && Tab1Create ? proVendorDisable ? true : false : AddNew == false && Tab1Modify ? proVendorDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        onClick={setVenderPLU}
                        color="success"
                        className="btn-sm"
                        disabled={Gen_VendorPLU_Enabled ? true : AddNew && Tab1Create ? proVendorDisable ? true : false : AddNew == false && Tab1Modify ? proVendorDisable ? true : false : true}
                        size="sm"
                      >
                        <i
                          className="mdi mdi-plus-circle"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row hidden={ProUnitDisable && hideFields}>
                    <Col>
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Unit *"
                        optionGroup={optionUnit}
                        selectedGroup={Unit}
                        onChange={Gen_Unit}
                        disabled={Gen_Unit_Enabled ? true : AddNew && Tab1Create ? ProUnitDisable ? true : false : AddNew == false && Tab1Modify ? ProUnitDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={ProPurModeDisable && hideFields}>
                    <Col>
                      <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Purchasing Mode"
                        optionGroup={optionPurchasingMode}
                        selectedGroup={PurchasingMode}
                        onChange={Gen_PurchasingMode}
                        disabled={Gen_PurchasingMode_Enabled ? true : AddNew && Tab1Create ? ProPurModeDisable ? true : false : AddNew == false && Tab1Modify ? ProPurModeDisable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={ProLan1Disable && hideFields}>
                    <Col>

                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Language 1"
                        textType="text"
                        maxLength="100"
                        value={Language1}
                        onChange={Gen_Language1}
                        disabled={Gen_Language1_Enabled ? true : AddNew && Tab1Create ? ProLan1Disable ? true : false : AddNew == false && Tab1Modify ? ProLan1Disable ? true : false : true}
                      />

                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row hidden={ProLan2Disable && hideFields}>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Language 2"
                        textType="text"
                        maxLength="100"
                        value={Language2}
                        onChange={Gen_Language2}
                        disabled={Gen_Language2_Enabled ? true : AddNew && Tab1Create ? ProLan2Disable ? true : false : AddNew == false && Tab1Modify ? ProLan2Disable ? true : false : true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                    </Col>
                  </Row>
                  <Row hidden={ProReturnDisable && hideFields}>
                    <Col>
                      <DPTextBoxTow
                        rowClass="mb-4-sm"
                        labelText="Return/Empty"
                        textType="text"
                        maxLength="100"
                        value1={Return_Code}
                        value2={Return_Description}
                        onChange1={Return_Code_OnChange}
                        onKeyPress={Return_Code_onKeyPress}
                        onBlur1={Return_Code_onBlur}
                        disabled1={Gen_StockCode_Enabled ? true : AddNew && Tab1Create ? ProReturnDisable ? true : false : AddNew == false && Tab1Modify ? ProReturnDisable ? true : false : true}
                        disabled2={true}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        size="sm"
                        color="success"
                        className="btn-sm"
                        onClick={Return_DataSearch}
                        disabled={Gen_StockCode_Enabled ? true : AddNew && Tab1Create ? ProReturnDisable ? true : false : AddNew == false && Tab1Modify ? ProReturnDisable ? true : false : true}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>
                </Col>

                <Col sm={12} md={5} className="mb-4-sm">
                  {ProCSDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Pack/Case Size"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_CaseSize}
                    onChange={Gen_CaseSize_OnChange}
                    disabled={Gen_CaseSize_Enabled ? true : AddNew && Tab1Create ? ProCSDisable ? true : false : AddNew == false && Tab1Modify ? ProCSDisable ? true : false : true}
                    onBlur={Gen_CaseSize_onBlur}
                  />}

                  {ProCostDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Pack cost price *"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_CostPrice.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt, minimumFractionDigits: txnDecimalAmt })}
                    onChange={Gen_CostPrice_OnChange}
                    // disabled={Gen_CostPrice_Enabled ? true : AddNew && Tab1Create ? ProCostDisable ? true : false : AddNew == false && Tab1Modify ? ProCostDisable ? true : false : true}
                    disabled={Gen_CostPrice_Enabled ? true : AddNew && Tab1Create ? ProCostDisable ? true : false : AddNew == false ? true :true}
                    onBlur={Gen_CostPrice_onBlur}
                  />}

                  {ProMarkupDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Markup Cost(%)"
                    textType="text"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_MarkupCost}
                    onChange={Gen_MarkupCost_OnChange}
                    disabled={Gen_MarkupCost_Enabled ? true : AddNew && Tab1Create ? ProMarkupDisable ? true : false : AddNew == false && Tab1Modify ? ProMarkupDisable ? true : false : true}
                    onBlur={Gen_MarkupCost_onBlur}
                  />}

                  {ProSellDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Unit Selling Price *"
                    textType="text"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_SellingPrice.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt, minimumFractionDigits: txnDecimalAmt })}
                    onChange={Gen_SellingPrice_OnChange}
                    //  disabled={Gen_SellingPrice_Enabled ? true : AddNew && Tab1Create ? ProSellDisable ? true : false : AddNew == false && Tab1Modify ? ProSellDisable ? true : false : true}
                    disabled={Gen_SellingPrice_Enabled ? true : AddNew && Tab1Create ? ProSellDisable ? true : false : AddNew == false ? true : true}
                    onBlur={Gen_SellingPrice_onBlur}
                  />}
                  {ProPackDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Pack Price"
                    textType="text"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_PackPrice.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt, minimumFractionDigits: txnDecimalAmt })}
                    onChange={Gen_PackPrice_OnChange}
                    disabled={Gen_PackPrice_Enabled ? true : AddNew && Tab1Create ? ProPackDisable ? true : false : AddNew == false && Tab1Modify ? ProPackDisable ? true : false : true}
                    onBlur={Gen_PackPrice_onBlur}
                  />}

                  {ProAVGDisable && hideFields ? null : <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Average Cost"
                    textType="text"
                    maxLength="10"
                    textAlign="right"
                    value={Gen_AvgCost.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt, minimumFractionDigits: txnDecimalAmt })}
                    onChange={Gen_AvgCost_OnChange}
                    disabled={Gen_AvgCost_Enabled ? true : AddNew && Tab1Create ? ProAVGDisable ? true : false : AddNew == false && Tab1Modify ? ProAVGDisable ? true : false : true}
                  />}
                  <Row>
                    <Col sm={12} md={8} className="mb-4-sm">
                      {ProFixGPDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Fixed GP"
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={Gen_FixedGP}
                        onChange={Gen_FixedGP_OnChange}
                        disabled={Gen_FixedGP_Enabled ? true : AddNew && Tab1Create ? ProFixGPDisable ? true : false : AddNew == false && Tab1Modify ? ProFixGPDisable ? true : false : true}
                        onBlur={Gen_FixedGP_onBlur}
                        colWidth={6}
                      />}
                      {ProGPDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Current GP (cost)"
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={parseFloat(Gen_CurrentGP).toFixed(2)}
                        onChange={Gen_CurrentGP_OnChange}
                        disabled={Gen_CurrentGP_Enabled ? true : AddNew && Tab1Create ? ProGPDisable ? true : false : AddNew == false && Tab1Modify ? ProGPDisable ? true : false : true}
                        colWidth={6}
                      />}
                      {ProMaxDiscDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Max Discount(%)"
                        textType="text"
                        maxLength="3"
                        textAlign="right"
                        value={Gen_MaxDis}
                        onChange={Gen_MaxDis_OnChange}
                        disabled={Gen_MaxDis_Enabled ? true : AddNew && Tab1Create ? ProMaxDiscDisable ? true : false : AddNew == false && ProMaxDiscDisable ? proDescEnable ? true : false : true}
                        onBlur={Gen_MaxDis_onBlur}
                        colWidth={6}
                      />}
                      {ProMaxDiscAmtDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Max Discount Amount "
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={Gen_MaxDisAmt}
                        onChange={Gen_MaxDisAmt_OnChange}
                        disabled={Gen_MaxDisAmt_Enabled ? true : AddNew && Tab1Create ? ProMaxDiscAmtDisable ? true : false : AddNew == false && Tab1Modify ? ProMaxDiscAmtDisable ? true : false : true}
                        onBlur={Gen_MaxDisAmt_onBlur}
                        colWidth={6}
                      />}

                      {ProMaxAllowQtyDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Max Allowed Quantity"
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={Gen_MaxAllowQty}
                        onChange={Gen_MaxAllowQty_OnChange}
                        disabled={Gen_MaxAllowQty_Enabled ? true : AddNew && Tab1Create ? ProMaxAllowQtyDisable ? true : false : AddNew == false && Tab1Modify ? ProMaxAllowQtyDisable ? true : false : true}
                        onBlur={Gen_MaxAllowQty_onBlur}
                        colWidth={6}
                      />}

                      {ProMinSellDisable && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Min Sell Value"
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={dbMinSell}
                        onChange={Gen_SetMinSell_OnChange}
                        disabled={Gen_MaxAllowQty_Enabled ? true : AddNew && Tab1Create ? ProMinSellDisable ? true : false : AddNew == false && Tab1Modify ? ProMinSellDisable ? true : false : true}
                        onBlur={Gen_SetMinSell_onBlur}
                        colWidth={6}
                      />}


                      {shortExpieryHide && hideFields ? null : <DPTextBox
                        rowClass="mb-3-sm"
                        labelText="Short Expiry Days"
                        textType="text"
                        maxLength="10"
                        textAlign="right"
                        value={proFormData.shortExpiryDays}
                        onChange={(e) => {

                          const validatedValue = Numeric(e.target, 5, 0, false)

                          setProFormData(prev => ({
                            ...prev,
                            shortExpiryDays: validatedValue,
                          }));


                        }}
                        disabled={Gen_Desc_Enabled ? true : shortExpieryDisable ? true : AddNew && Tab1Create ? shortExpieryHide ? true : false : AddNew == false && Tab1Modify ? shortExpieryHide ? true : false : true}
                        onBlur={(e) => {

                          if (e.target.value == "") {
                            setProFormData(prev => ({
                              ...prev,
                              shortExpiryDays: 0,
                            }));
                          }

                        }}
                        colWidth={6}
                      />}

                    </Col>
                    <Col sm={12} md={4} className="mb-4-sm">
                      {ProPictureDisable == false ?
                        <DPImage
                          labelText={imagesrc}
                          onClick={showPop}
                          style={{ cursor: 'pointer' }}
                        ></DPImage> : null}
                      {/*<DPZoom
                    imgSrc={imagesrc}
                  />*/}
                      <DPImagePop
                        toggle={showPop}
                        isOpen={isOpen}
                        width={'400px'}
                        height={'400px'}
                        ImgSrc={imagesrc}
                      />
                      <DPTagPop
                        toggle={showPopT}
                        isOpen={isOpenT}
                        ImgSrc={Tag}
                        Description={Gen_POSDesc}
                        Code={Gen_Code}
                        Price={Gen_SellingPrice.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt, minimumFractionDigits: txnDecimalAmt })}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                  <center>
                    <Button
                      color="success"
                      className="btn-sm"
                      width={'100%'}
                      onClick={showPopT}
                      disabled={AddNew == true ? true : Gen_MaxDisAmt_Enabled == true ? true : false}
                    >Tag</Button>
                    <br />
                    <hr />
                  </center>
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={Gen_Code_Enabled}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />

                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: Gen_Code_Enabled == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>

                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={ProductExcelUpload} download="Product_Excel_Upload" data-tip title="Product excel upload format download"
                        style={{ pointerEvents: Gen_Code_Enabled ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: Gen_Code_Enabled == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>

                </Col>
                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={HeadColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={"Product Search"}
                  SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={Hed_CodeSearchOpen}
                  toggle={Hed_CodeSearchTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"PRODUCTM"}
                  MenuCode={menuCode}
                  KeyVal={'PRD'}
                  searchBy={'PLU_CODE'}
                  FilterStr={filterBy}
                  showImage={true}
                />
                {/* Return search button*/}
                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={HeadColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={"Product Search"}
                  SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={Return_CodeSearchOpen}
                  toggle={Return_CodeSearchTrigger}
                  getSelect={GetSelectReturnRow}
                  APIURL={ApiURL}
                  URLPath={"PRODUCTM"}
                  MenuCode={menuCode}
                  KeyVal={'PRD'}
                  searchBy={'PLU_CODE'}
                  FilterStr={'a'}
                />
                <Col sm={12} md={1} className="mb-4-sm"></Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default ProductGenContent
